<template>
  <div class="Comparison">
    <div class="title row-center" style="justify-content: space-between;">
      <div class="row-center">
        <el-date-picker
          :editable="false"
          :picker-options="pickerOptions"
          :clearable="false"
          class="dateSelect"
          v-model="date"
          :format="radio === 'week' ? 'yyyy 第 WW 周' : ''"
          :type="radio === 'day' ? 'date' : radio"
          :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
        >
        </el-date-picker>

        <div class="radio">
          <el-radio v-model="radio" label="year">年</el-radio>
          <el-radio v-model="radio" label="month">月</el-radio>
          <el-radio v-model="radio" label="week">周</el-radio>
          <el-radio v-model="radio" label="day">日</el-radio>
        </div>
        <el-button plain class="btn per" @click="perD" v-if="radio === 'day'"
          >上一日</el-button
        >
        <el-button plain class="btn per" @click="perM" v-if="radio === 'month'"
          >上一月</el-button
        >
        <el-button plain class="btn per" @click="perW" v-if="radio === 'week'"
          >上一周</el-button
        >
        <el-button plain class="btn per" @click="perY" v-if="radio === 'year'"
          >上一年</el-button
        >
        <el-button
          class="btn next"
          plain
          @click="nextD"
          v-if="radio === 'day'"
          :disabled="nextDayDisabled"
          >下一日
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextM"
          v-if="radio === 'month'"
          :disabled="nextDayDisabled"
        >
          下一月
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextW"
          v-if="radio === 'week'"
          :disabled="nextDayDisabled"
        >
          下一周
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextY"
          v-if="radio === 'year'"
          :disabled="nextDayDisabled"
          >下一年
        </el-button>
      </div>
      <div class="right">
        <div class="area" @click.stop="listShow = !listShow">
          <span>区域一：{{ currentLoop.name }}</span
          ><img src="../../../assets/img/change0.png" alt="" />
        </div>
        <div class="area" @click.stop="listShow1 = !listShow1">
          <span>区域二：{{ currentLoop1.name }}</span
          ><img src="../../../assets/img/change0.png" alt="" />
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="box">
        <div class="tt">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              分类能耗对比·<label for="">{{ downval
              }}<img src="../../../assets/img/ardown.png" alt="" /></label>
            </span>
            <el-dropdown-menu slot="dropdown" style="width:6vw">
              <el-dropdown-item v-for="item in downlist" :command="item">{{
                item.label
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-checkbox v-model="showMax" style="float:right"
            >最值分析</el-checkbox
          >
        </div>
        <div
         v-loading="loading"
          class="echarts row-center"
          style="justify-content: space-between"
          :class="{ showMax }"
        >
          <div class="left" style="height:30vh;text-align: center;">
            <Curve
              v-if="diagramData && canvasShow"
              :chartsData="diagramData"
            ></Curve>
            <img
              class="nodata"
              v-else
              src="../../../assets/img/not_found_data.png"
              alt=""
            />
          </div>

          <div
            v-show="showMax"
            class="max-right row-center"
            style="justify-content: space-between"
            v-if="diagramData && canvasShow"
          >
            <div
              class="row-max row-center"
              style="justify-content: space-between"
              v-for="(item, index) in diagramData.legend.data"
              :key="index"
            >
              <div class="max-name row-center">{{ item }}</div>
              <div
                class="details column-center"
                style="justify-content: space-evenly"
              >
                <div
                  class="row-center"
                  style="width: 100%; justify-content: flex-start"
                >
                  <span>最大值</span><span>{{ max(item) }}</span
                  ><span></span>
                </div>
                <div
                  class="row-center"
                  style="width: 100%; justify-content: flex-start"
                >
                  <span>最小值</span><span>{{ min(item) }}</span
                  ><span></span>
                </div>
                <div
                  class="row-center"
                  style="width: 100%; justify-content: flex-start"
                >
                  <span>平均值</span><span>{{ average(item) }}</span
                  ><span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box" >
        <div class="tt">分项能耗对比</div>
        <div class="" style="height:30vh" v-loading="Itemloading">
          <charts id="Comparison" :option="Comparison"></charts>
        </div>
      </div>
    </div>
    <div @click.stop="" ref="area">
      <Zone
        v-if="listShow"
        @closedArea="closedArea"
        @getcurrentLoop="getcurrentLoop"
        :currentLoop="currentLoop"
      ></Zone>
      <Zone
        v-if="listShow1"
        @closedArea="closedArea1"
        @getcurrentLoop="getcurrentLoop1"
        :currentLoop="currentLoop1"
      ></Zone>
    </div>
  </div>
</template>

<script>
import charts from "../../../components/Energy/charts";
import Zone from "../../../components/Energy/Zone.vue";
import {
  classifiedEnergyConsumption,
  BuildingItemEnergy,
} from "../../../api/power";
import { treeBuilding } from "../../../api/common";
import { floatFormat } from "../../../util/MathUtil";
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  dateToString,
  dayStart,
  dayEnd,
  addDay,
  getAppointedDate,
  getDiffDate,
  weekStart,
  weekEnd,
} from "../../../util/DateUtil";
import Curve from "../../../chart/Curve";
export default {
  components: {
    charts,
    Zone,
    Curve,
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      date: new Date(),
      radio: "day",
      listShow: false,
      listShow1: false,
      showMax: false,
      downval: "电",
      node: "electricity",
      downlist: [
        {
          value: "electricity",
          unit:"kWh",
          label: "电",
        },
        {
          value: "water",
          unit:"m³",
          label: "水",
        },
        {
          value: "heat",
          unit:"GJ",
          label: "热",
        },
        {
          value: "cooling",
          unit:"GJ",
          label: "冷",
        },
      ],
      currentLoop: {},
      currentLoop1: {},
      loops: [],
      diagramData: null,
      canvasShow: true,
      loading: true,
      Itemloading: true,
      ComparisonData: {},
      unit:"kWh"
    };
  },
  computed: {
    nextDayDisabled() {
      let timestamp = dateFormat("YY-mm-dd", new Date());
      let endtime = dateFormat("YY-mm-dd", this.date);
      if (this.radio === "year") {
        timestamp = dateFormat("YY", new Date());
        endtime = dateFormat("YY", this.date);
      } else if (this.radio === "month") {
        timestamp = dateFormat("YY-mm", new Date());
        endtime = dateFormat("YY-mm", this.date);
      } else if (this.radio === "week") {
        timestamp = dateFormat("YY-mm-dd", new Date());
        endtime = dateFormat("YY-mm-dd", addDay(this.date, 5));
      }
      if (endtime >= timestamp) {
        return true;
      } else {
        return false;
      }
    },
    changeData() {
      return [this.date, this.node, this.currentLoop, this.currentLoop1];
    },
    //最小值
    min() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (
          data[0].data.length === 0 ||
          data[0].data.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let minValue = Math.min(...data[0].data);
        let minTimeIndex = data[0].data.findIndex((item) => item == minValue);
        let minTime = this.diagramData.xAxis.data[minTimeIndex];
        return (
          floatFormat(Math.min(...data[0].data), 2) +
          ` (${this.formateTime(minTime)})`
        );
      };
    },
    //平均值
    average() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (
          data[0].data.length === 0 ||
          data[0].data.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let sum = 0;
        data[0].data.forEach((e) => (sum += +e));
        return floatFormat(sum / data[0].data.length, 2);
      };
    },
    //最大值
    max() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (
          data[0].data.length === 0 ||
          data[0].data.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let maxValue = Math.max(...data[0].data);
        let maxTimeIndex = data[0].data.findIndex((item) => item == maxValue);
        let maxTime = this.diagramData.xAxis.data[maxTimeIndex];
        return (
          floatFormat(Math.max(...data[0].data), 2) +
          ` (${this.formateTime(maxTime)})`
        );
      };
    },
    Comparison() {
      return {
        color: ["#0D94FF", "#5AD8A6"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: "18rem",
          },
          itemGap: 50,
        },
        grid: {
          left: 20,
          right: 20,
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["空调", "照明", "动力"],
        },
        yAxis: {
          type: "value",
          name: "kWh",
        },
        series: this.ComparisonData.seriesData,
      };
    },
  },
  watch: {
    changeData() {
      this.canvasDataRult();
      this.EnergyConsumption();
    },
    currentLoop() {
      this.listShow = false;
    },
    currentLoop1() {
      this.listShow1 = false;
    },
    radio(n) {
      this.date = new Date();
    },

    showMax(n, o) {
      this.reload();
    },
  },

  beforeDestroy() {
    document.removeEventListener("click", this.closePopover);
    document.removeEventListener("click", this.closePopover1);
  },
  mounted() {
    document.addEventListener("click", this.closePopover);
    document.addEventListener("click", this.closePopover1);
    this.GetreeBuilding();
  },
  methods: {
    //分类能耗对比
    EnergyConsumption() {
      this.Itemloading = true;
      let range = this.radio;
      let node = this.node;
      let promises = [];
      let currList = [this.currentLoop, this.currentLoop1];
      
      currList.forEach((element) => {
        let obj = {
          buildingId: element.id,
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          itemType: "",
          range: range.toUpperCase(),
        };
        promises.push(BuildingItemEnergy(obj));
      });

      Promise.all(promises).then((res) => {
        let pointsArray = res.map((r) =>
          r.data.data.result ? r.data.data.result : {}
        );
        let seriesData = [];
        let legendTitle = [];
        let num = 0;
        pointsArray.forEach((item, index) => {
          let data = [];
          for (let i in item) {
            data.push(item[i].toFixed(2));
          }
          let name = ["区域一：","区域二："]
          legendTitle.push(name[index]+currList[index].name);
          seriesData.push({
            name: name[index]+currList[index].name,
            type: "bar",
            barWidth: 120,
            data: data,
          });
        });
        this.Itemloading = false;
        this.ComparisonData = {
          seriesData: seriesData,
          legendTitle: legendTitle,
        };
      });
    },
    formateTime(string) {
      let array = string.split("");
      array.pop();
      if (array.length < 2) {
        return "0" + array[0] + ":00";
      } else {
        return array.join("") + ":00";
      }
    },
    reload() {
      this.canvasShow = !this.canvasShow;
      this.$nextTick(() => {
        this.canvasShow = !this.canvasShow;
      });
    },
    //楼栋
    GetreeBuilding() {
      treeBuilding().then((res) => {
        this.loops = res.data.data.tree;
        this.currentLoop = this.loops[0];
        this.currentLoop1 = this.loops[0].children[0];
        this.canvasDataRult();
        this.EnergyConsumption();
      });
    },
    //分类能耗对比
    canvasDataRult() {
      this.loading = true;
      let range = this.radio;
      let node = this.node;
      let promises = [];
      let xAxisData = [];
      if (this.radio == "year") {
        for (let i = 1; i <= 12; i++) {
          xAxisData.push(i + "月");
        }
      } else if (this.radio == "month") {
        for (let i = 1; i <= 31; i++) {
          xAxisData.push(i + "日");
        }
      } else if (this.radio == "week") {
        let startDate = weekStart(this.date).replace("T00:00:00Z", "");
        let endDate = weekEnd(this.date).replace("T00:00:00Z", "");
        let time = getDiffDate(startDate, endDate);
        for (let i = 0; i < time.length; i++) {
          xAxisData.push(time[i]);
        }
      } else if (this.radio == "day") {
        for (let i = 0; i < 24; i++) {
          xAxisData.push(i + "点");
        }
      }
      let currList = [this.currentLoop, this.currentLoop1];
      currList.forEach((element) => {
        let obj = {
          buildingId: element.id,
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          powerType: node.toUpperCase(),
          range: range.toUpperCase(),
        };
        promises.push(classifiedEnergyConsumption(obj));
      });

      Promise.all(promises).then((res) => {
        let pointsArray = res.map((r) =>
          r.data.data.result ? r.data.data.result : []
        );
        let seriesData = [];
        let legendTitle = [];
        let num = 0;
        let name = ["区域一：","区域二："]
        pointsArray.forEach((item, index) => {
          let data = item[node]
            .map((e) => {
              return e == null ? "" : e.toFixed(2);
            })
          seriesData.push({
            data: data,
            type: "line",
            name: name[index]+currList[index].name,
            smooth: true,
            areaStyle: {
              color:
                index == 0
                  ? "rgba(13, 148, 255, 0.3)"
                  : "rgba(90, 216, 166, 0.3)",
            },
          });
          legendTitle.push(name[index]+currList[index].name);
          if (data.filter(e=> e!=0).length <= 0) {
            num++;
          }
        });
        this.loading = false;
        if (num >= 2) {
          this.canvasShow = false;
          this.diagramData = false;
          return;
        } else {
          this.canvasShow = true;
        }
        this.$set(
          this,
          "diagramData",
          this.createCanvasData(legendTitle, xAxisData, seriesData)
        );
      });
    },
    createCanvasData(legendTitle, xAxisData, seriesData) {
      return {
        color: ["#0D94FF", "#5AD8A6"],
        tooltip: {
          trigger: "axis",
          textStyle:{
            align:'left'
          }
        },
        legend: {
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: "18rem",
          },
          itemGap: 50,
          data: legendTitle,
        },
        grid: {
          left: 20,
          right: 20,
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
        },
        yAxis: {
          type: "value",
          name: this.unit,
        },
        series: seriesData,
      };
    },
    getcurrentLoop(val) {
      this.currentLoop = val;
    },
    getcurrentLoop1(val) {
      this.currentLoop1 = val;
    },
    handleCommand(command) {
      this.downval = command.label;
      this.node = command.value;
      this.unit = command.unit;
    },
    closePopover(e) {
      let self = this;
      if (self.$refs.area && !self.$refs.area.contains(e.target)) {
        if (self.listShow == true) {
          self.listShow = false;
        }
      }
    },
    closePopover1(e) {
      let self = this;
      if (self.$refs.area && !self.$refs.area.contains(e.target)) {
        if (self.listShow1 == true) {
          self.listShow1 = false;
        }
      }
    },
    closedArea() {
      this.listShow = false;
    },
    closedArea1() {
      this.listShow1 = false;
    },
    perW() {
      let week = getAppointedDate(this.date, 1, 1);
      this.date = new Date(week.startDate);
    },
    nextW() {
      let week = getAppointedDate(this.date, 1, -1);
      this.date = new Date(week.startDate);
    },
    perD() {
      this.date = perDay(this.date);
    },
    nextD() {
      this.date = nextDay(this.date);
    },
    perM() {
      this.date = perMonth(this.date);
    },
    nextM() {
      this.date = nextMonth(this.date);
    },
    perY() {
      this.date = perYear(this.date);
    },
    nextY() {
      this.date = nextYear(this.date);
    },
  },
};
</script>

<style scoped lang="less">
.showMax {
  div.left {
    .w(1220) !important;
  }
}
.echarts {
  .left {
    width: 100%;
  }

  .max-right {
    .w(282);
    .h(340);
    margin-right: 24rem;

    .row-max {
      width: 100%;
      background-color: rgba(0, 43, 102, 0.02);
      // height: 88px;
      margin-bottom: 10px;

      .details {
        .w(185);
        height: 100%;
        padding: 12rem 0;

        span {
          margin-right: 8rem;
          color: rgba(13, 148, 255, 1);
          font-size: 16rem;

          &:first-child {
            color: #333333;
          }
        }
      }

      .max-name {
        height: 100%;
        .w(96);
        font-size: 18rem;
        font-weight: bold;
        color: #333333;
      }
    }
  }
}

.nodata {
  text-align: center;
  margin-top: 20px;
}
.Comparison {
  height: 100%;
  font-size: 18rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: #F5F7F9;
}
.title {
  background: #ffffff;
  height: 8vh;
  padding: 0 30rem;
  width: 100%;

  .demonstration {
    margin-right: 10rem;
  }
  .block {
    margin-right: 80rem;
  }
  .dateSelect {
    margin-right: 10rem;
  }
  .per {
    margin-left: 10rem;
  }
  .el-radio {
    margin-right: 20rem;
  }
  .area {
    height: 3.5vh;
    width: 15vw;
    line-height: 3.5vh;
    background: #eeeeee;
    border-radius: 18rem;
    padding: 0 20rem;
    display: inline-block;
    margin: 0 10rem;
    float: left;
    cursor: pointer;
    span {
      max-width: 11vw;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    img {
      float: right;
      margin-top: 1vh;
    }
  }
}
.cont {
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .box {
    height: 49%;
    background: #fff;
    width: 100%;
    padding: 20rem;
  }
  .tt {
    font-size: 18rem;
    font-weight: bold;
    height: 5vh;
    span {
      font-size: 18rem;
      color: #333;
      float: left;
      cursor: pointer;
      label{
        cursor: pointer;
      }
      img {
        vertical-align: middle;
        margin-left: 5px;
      }
    }
  }
}
.el-dropdown-menu {
  text-align: center;
}
</style>
